import { useSelector } from 'react-redux'
import { getRaffle } from '@/features/Raffle/reducer';
import { Player } from 'video-react'
import parse from 'html-react-parser'
import { useTranslation } from 'react-i18next';
import { MainButton } from "@vkruglikov/react-telegram-web-app";

export default function MemberRefNew({ close }) {
	const raffle = useSelector(getRaffle)
	const { t } = useTranslation()

	const renderImage = () => {
		return raffle.image ?
			<div className='boxImage' style={{marginBottom: raffle.preview_top ? '16px' : '0'}}>
				{raffle.image.slice(-4) === '.mp4' ?
					<Player src={raffle.image} />
				:
					<img src={raffle.image} alt='' />
				}
			</div>
		: null;
	}

	return (
		<div className='boxText'>
			<div className='boxText_body'>
				{raffle.preview_top ? renderImage() : null}

				{parse(raffle.text)}

				{!raffle.hide_info ?
					<>
						<br/><br/>
						{ t('features.raffle.content.members') } <b>{raffle.members_count}</b><br/>
						{ t('features.raffle.content.winPlace') } <b>{raffle.winners}</b><br/>
						{ t('features.raffle.content.date') } <b>{raffle.date_end}</b>
					</>
				: null }

				{!raffle.preview_top ? renderImage() : null}
			</div>
			<MainButton
				onClick={close}
				text={ t('features.raffle.content.participate') }
			/>
		</div>
	)
}
